import { useMemo } from 'react';
import loading1 from '../../assets/loading_1.gif';
import loading2 from '../../assets/loading_2.gif';

function EditorLoading( { message } ) {
    const selectedGif = useMemo(() => {
        const random = Math.random();
        return random < 0.05 ? loading2 : loading1;
    }, []);

    return(
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: '#000',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <h1 style={{ color: '#fff' }}>{ message || "Getting the customizer ready..."}</h1>
            <img src={selectedGif} alt="Loading..." style={{ width: '400px', height: '400px' }} />
        </div>
    );
}

export default EditorLoading;